import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const STATS = [["225", "exercises with videos and form tips"], ["321", "everyday foods, 58 Aussie favourites"], ["0", "ads, tracking or data sold"]];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="manifesto-section" className="relative overflow-hidden border-y border-white/[0.07]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-32">
        <div className="relative h-[420px] overflow-hidden rounded-[2rem] lg:col-span-5 lg:h-auto">
          <motion.img style={{ y }} src="/images/athlete.jpg" alt="Athlete preparing for a heavy squat" className="photo-treat absolute inset-0 h-[125%] w-full object-cover object-top" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,transparent_10%,#0e0f12_85%)]" />
        </div>
        <div className="flex flex-col justify-center lg:col-span-7">
          <Reveal><Overline>The vision</Overline></Reveal>
          <Reveal delay={0.05}>
            <p className="mt-6 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-5xl lg:text-6xl">
              Spotter isn't just about lifting weights. It's about <span className="text-grad">discipline</span>, better habits and becoming a stronger version of you.
            </p>
          </Reveal>
          <div className="mt-14 grid grid-cols-3 gap-4 border-t border-white/10 pt-8">
            {STATS.map(([n, l], i) => (
              <Reveal key={l} delay={i * 0.08}>
                <p data-testid={`stat-${i}`} className="font-display text-6xl font-black text-grad sm:text-7xl">{n}</p>
                <p className="mt-1 text-xs text-[#b3b8c1] sm:text-sm">{l}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
